import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const priceFormatter = new Intl.NumberFormat("ru-RU");

export function formatPrice(price: number): string {
  return priceFormatter.format(price);
}

const ruPlural = new Intl.PluralRules("ru");

/**
 * Russian noun form for a count: `pluralRu(5, ["товар", "товара", "товаров"])` → "товаров".
 * Forms are [one, few, many] — 1 товар, 2 товара, 5 товаров (and 21 товар, 11 товаров).
 */
export function pluralRu(count: number, [one, few, many]: readonly [string, string, string]) {
  switch (ruPlural.select(count)) {
    case "one":
      return one;
    case "few":
      return few;
    default:
      return many;
  }
}

export const PRODUCT_FORMS = ["товар", "товара", "товаров"] as const;
